import { Lock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function PlaceholderTab({ title, description, phase, restricted }) {
  return (
    <Card data-testid={`placeholder-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <CardContent className="py-14 text-center">
        <div className={`mx-auto flex h-12 w-12 items-center justify-center rounded-full mb-4 ${restricted ? "bg-red-50" : "bg-brand-light"}`}>
          <Lock className={`h-6 w-6 ${restricted ? "text-red-500" : "text-primary"}`} />
        </div>
        <h3 className="font-heading text-lg font-semibold text-slate-900">{title}</h3>
        <p className="text-sm text-slate-600 mt-1 max-w-md mx-auto">{description}</p>
        <p className="text-xs uppercase tracking-wide text-slate-400 mt-3">Coming in {phase}</p>
      </CardContent>
    </Card>
  );
}
